import { IAnalyticsUser } from '../../types/analytics';
import { IApplicationState } from '../../types/redux';
import { IAuthUser } from '../../types/userData';
import { selectUser } from '../user';

export function selectAnalyticsUser(state: IApplicationState): IAnalyticsUser {
  const user = selectUser(state);

  return {
    userId: (user as IAuthUser).userId || undefined,
  };
}
